"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetType = void 0;
var AssetType;
(function (AssetType) {
    AssetType["AUDIO"] = "AUDIO";
    AssetType["IMAGE"] = "IMAGE";
    AssetType["TEXT"] = "TEXT";
    AssetType["BACKGROUND"] = "BACKGROUND";
    AssetType["COLOR"] = "COLOR";
    AssetType["PARTICLE"] = "PARTICLE";
    AssetType["SPRITE_SHEET"] = "SPRITESHEET";
    AssetType["PARALLAX"] = "PARALLAX";
})(AssetType || (exports.AssetType = AssetType = {}));
